// extracted by mini-css-extract-plugin
export default {"tabsStyle":"summary-routine-styles_tabsStyle__9qbAN"};